export default "__VITE_ASSET__M9rx9I_H__"